import { render, staticRenderFns } from "./custom-top-flag-select.vue?vue&type=template&id=1c1613d7&"
import script from "./custom-top-flag-select.vue?vue&type=script&lang=js&"
export * from "./custom-top-flag-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports